import request from '@/utils/request'

/**
 * 查询商品信息
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 入库调拨单
 * @param {Object} data 提交数据
 * @returns {Promise} Promise对象
 */
export function warehousingAllocationOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/allocationOrder/warehousingAllocationOrder',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}